export var getShouldExcludeFunc = function getShouldExcludeFunc(defaultConditions) {
  return function (_ref) {
    var _ref$conditions = _ref.conditions,
      conditions = _ref$conditions === void 0 ? defaultConditions : _ref$conditions,
      conditionParams = _ref.conditionParams;
    return conditions.some(function (condition) {
      return condition(conditionParams);
    });
  };
};
export default getShouldExcludeFunc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/exclusions.js
// module id = 1361
// module chunks = 11